import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { FONT_SIZE } from "../message-banner/constants";
import { Button } from "../button";
import { styledWithTheme } from "../context";
import { Col, Flex, Row } from "../layout";
import { Text } from "../text";
import { A11Y_SIZE, getContentHeight, px } from "../utils";
export var DragAndDropRow = styledWithTheme(Row)(function (_ref) {
  var disabled = _ref.disabled,
      selectors = _ref.theme.selectors;
  return {
    alignItems: 'center',
    border: "1px dashed ".concat(selectors.color(disabled ? 'neutral70' : 'primary70')),
    cursor: disabled ? 'not-allowed' : 'pointer',
    gap: px(selectors.space('S100')),
    padding: px(selectors.space('S200'))
  };
});
export var DragAndDropText = styledWithTheme(Text)(function (_ref2) {
  var disabled = _ref2.disabled,
      selectors = _ref2.theme.selectors;
  return _objectSpread({
    fontSize: selectors.fontSize('T200'),
    marginLeft: px(selectors.space('S100'))
  }, disabled && {
    color: selectors.color('neutral70')
  });
});
export var FailedFileText = /*#__PURE__*/_styled(Text, {
  target: "eaakjow0"
})(process.env.NODE_ENV === "production" ? {
  name: "1hg9omi",
  styles: "word-break:break-all;"
} : {
  name: "1hg9omi",
  styles: "word-break:break-all;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export var FileRow = styledWithTheme(Flex.withComponent('li', {
  target: "eaakjow1"
}))(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    justifyContent: 'space-between',
    minHeight: px(A11Y_SIZE),
    boxSizing: 'content-box',
    ':not(:last-child)': {
      borderBottom: "1px solid ".concat(selectors.color('neutral30')),
      paddingBottom: px(selectors.space('S200'))
    },
    ':not(:first-of-type)': {
      paddingTop: px(selectors.space('S200'))
    }
  };
});
export var FileSubRow = styledWithTheme(Row)(function (_ref4) {
  var selectors = _ref4.theme.selectors;
  return {
    alignItems: 'center',
    gap: px(selectors.space('S200')),
    wordBreak: 'break-all'
  };
});
export var UploadButton = styledWithTheme(Button)(function (_ref5) {
  var isInDropZone = _ref5.isInDropZone,
      selectors = _ref5.theme.selectors;
  return _objectSpread({
    fontSize: selectors.fontSize('T200')
  }, isInDropZone && {
    paddingLeft: px(selectors.space('S200')),
    paddingRight: px(selectors.space('S200'))
  });
});
export var IconButton = styledWithTheme(Button)(function (_ref6) {
  var baseColor = _ref6.baseColor,
      selectors = _ref6.theme.selectors;
  return {
    ':active': {
      borderColor: selectors.color("".concat(baseColor, "80"))
    },
    ':focus': {
      borderColor: selectors.color("".concat(baseColor, "80")),
      ':before': {
        borderColor: selectors.color("".concat(baseColor, "80"))
      }
    },
    ':hover': {
      borderColor: selectors.color("".concat(baseColor, "70"))
    }
  };
});
export var ItemsCol = styledWithTheme(Col.withComponent('ul', {
  target: "eaakjow2"
}))(function (_ref7) {
  var selectors = _ref7.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral05'),
    padding: px(selectors.space('S200'))
  };
});
ItemsCol.defaultProps = {
  role: 'list'
};
export var ErrorsText = styledWithTheme(Text)(function (_ref8) {
  var selectors = _ref8.theme.selectors;
  var iconLineHeight = selectors.lineHeight(FONT_SIZE);
  var iconFontSize = selectors.fontSize(FONT_SIZE);
  var height = getContentHeight(iconLineHeight, iconFontSize);
  return {
    alignItems: 'center',
    display: 'inline-flex',
    height: height
  };
});
export var ErrorsButtonsRow = styledWithTheme(Row)(function (_ref9) {
  var selectors = _ref9.theme.selectors;
  return {
    gap: px(selectors.space('S200')),
    justifyContent: 'flex-end'
  };
});